<template>
  <div>
    <span class="title">是否是党员:</span>
    <el-select v-model="value" placeholder="请选择是否是党员" clearable>
      <el-option label="非党员" :value="0"></el-option>
      <el-option label="党员" :value="1"></el-option>
      <el-option label="全部" :value="-1"></el-option>
    </el-select>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "CCPSelect",
  
  mixins: [BaseVue],
  
  data() {
    return {
      value: null
    };
  },
  
  methods: {
    init() {
      this.value = "";
    }
  },
  
  created() {
    // 创建时的逻辑
  },
  
  watch: {
    value: {
      handler(newVal) {
        // console.log("on value changed", newVal);
        this.$emit("onValueChanged", newVal);
      }
    }
  }
};
</script>
<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  display: inline-block;
  padding-left: 10px;
  margin-right: 10px;
}
</style>